import React from "react";

const MUACicon = () => {
  return (
    <svg width="20" height="26" viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 25.5C7.14583 25.5 4.76562 24.5208 2.85938 22.5625C0.953125 20.6042 0 18.1667 0 15.25C0 13.1667 0.828125 10.901 2.48438 8.45312C4.14062 6.00521 6.64583 3.35417 10 0.5C13.3542 3.35417 15.8594 6.00521 17.5156 8.45312C19.1719 10.901 20 13.1667 20 15.25C20 18.1667 19.0469 20.6042 17.1406 22.5625C15.2344 24.5208 12.8542 25.5 10 25.5ZM10 23C12.1667 23 13.9583 22.2656 15.375 20.7969C16.7917 19.3281 17.5 17.4792 17.5 15.25C17.5 13.7292 16.8698 12.0104 15.6094 10.0938C14.349 8.17708 12.4792 6.08333 10 3.8125C7.52083 6.08333 5.65104 8.17708 4.39062 10.0938C3.13021 12.0104 2.5 13.7292 2.5 15.25C2.5 17.4792 3.20833 19.3281 4.625 20.7969C6.04167 22.2656 7.83333 23 10 23ZM6.25 20.5H13.75V18H6.25V20.5ZM8.75 16.75H11.25V14.25H13.75V11.75H11.25V9.25H8.75V11.75H6.25V14.25H8.75V16.75Z" fill="#EA614F"/>
</svg>

  );
};

export default MUACicon;